module.exports = __webpack_public_path__ + "img/ricelog_pinicon_102.954dca09.png";